import * as actions from '../actionTypes'

const initialState = {
  caseNumber: '',
  confirmCaseNumber: '',
  paymentAmount: '',
  paymentAmountFull: '',
  amountOwing: '',
  minPaymentAmount: '',
  caseSotId: '',
  receiptDetail: '',
  caseType: '',
  cases: [],
  editCaseNumber: '',
  emailAddress: '',
  confirmEmailAddress: '',
}

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CASE_NUMBER: {
      return {
        ...state,
        caseNumber: action.payload.description,
      }
    }
    case actions.CONFIRM_CASE_NUMBER: {
      return {
        ...state,
        confirmCaseNumber: action.payload.description,
      }
    }
    case actions.AMOUNT_OWING: {
      return {
        ...state,
        amountOwing: action.payload.description,
      }
    }
    case actions.PAYMENT_AMOUNT: {
      return {
        ...state,
        paymentAmount: action.payload.description,
      }
    }
    case actions.PAYMENT_AMOUNT_FULL: {
      return {
        ...state,
        paymentAmountFull: action.payload.description,
      }
    }
    case actions.MIN_PAYMENT_AMOUNT: {
      return {
        ...state,
        minPaymentAmount: action.payload.description,
      }
    }
    case actions.CASE_SOT_ID: {
      return {
        ...state,
        caseSotId: action.payload.description,
      }
    }
    case actions.RECEIPT_DETAIL: {
      return {
        ...state,
        receiptDetail: action.payload.description,
      }
    }
    case actions.CASE_TYPE: {
      return {
        ...state,
        caseType: action.payload.description,
      }
    }
    case actions.EMAIL_ADDRESS: {
      return {
        ...state,
        emailAddress: action.payload.description,
      }
    }
    case actions.CONFIRM_EMAIL_ADDRESS: {
      return {
        ...state,
        confirmEmailAddress: action.payload.description,
      }
    }
    case actions.EDIT_CASE_NUMBER: {
      return {
        ...state,
        editCaseNumber: action.payload.caseNumber,
      }
    }
    case actions.ADD_CASE: {
      return {
        ...state,
        cases: [...state.cases, action.payload],
      }
    }
    case actions.EDIT_CASE: {
      return {
        ...state,
        cases: state.cases.map((caseInfo) => (caseInfo.caseNumber === state.editCaseNumber ? action.payload : caseInfo)),
      }
    }
    case actions.DELETE_CASE: {
      return {
        ...state,
        cases: state.cases.filter((caseInfo) => caseInfo.caseNumber !== action.payload.caseNumber),
      }
    }
    case actions.CLEAR_CASE_INFO: {
      return {
        ...state,
        caseNumber: initialState.caseNumber,
        confirmCaseNumber: initialState.confirmCaseNumber,
        paymentAmount: initialState.paymentAmount,
        minPaymentAmount: initialState.minPaymentAmount,
        amountOwing: initialState.amountOwing,
        caseSotId: initialState.caseSotId,
        receiptDetail: initialState.receiptDetail,
        caseType: initialState.caseType,
      }
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default AppReducer
